import {Dispatch, FC, SetStateAction, useState} from 'react'
import {SearchSelectOption} from '../../../../../../../_metronic/helpers/components/SearchSelect'
import {CustomerEditModalForm} from '../../../../customer-management/customers-list/customer-edit-modal/CustomerEditModalForm'

type props = {
  buyerSelected: {
    buyerSelected: SearchSelectOption | undefined
    setBuyerSelected: Dispatch<SetStateAction<SearchSelectOption | undefined>>
  }

  step: {
    step: number
    setStep: Dispatch<SetStateAction<number>>
  }
}

const AddCustomer: FC<props> = ({buyerSelected, step}) => {
  const [type, setType] = useState<number | undefined>(1)
  return (
    <>
      <CustomerEditModalForm
        type={{type: type, setType: setType}}
        callBack={(data) => {
          buyerSelected.setBuyerSelected({
            value: data?.id,
            label: data?.nm,
          })
          step.setStep(2)
        }}
      />
    </>
  )
}

export {AddCustomer}
